import CircularProgress from '@mui/material/CircularProgress';
import React, { CSSProperties } from 'react';

const LargeCenterSpinner = () => {
	const style: CSSProperties = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
		position: 'fixed',
		color: 'rgb(2, 69, 122)',
		backgroundColor: 'rgba(107, 116, 127, 0.2)',
		top: '0',
		left: '0',
		zIndex: 100,
	};

	return (
		<div style={style}>
			<CircularProgress color='inherit' />
		</div>
	);
};

export default LargeCenterSpinner;
